<fm-loading-spinner id="spinner" [isLoading]="isLoading"></fm-loading-spinner>
